import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateAdapter extends NgbDateAdapter<string> {

  readonly DELIMITER = '/';

  fromModel(value: string | Date | null): NgbDateStruct | null {
    if (!value) return null;
    
    let date: Date;
    
    if (value instanceof Date) {
      date = value;
    } else if (typeof value === 'string') {
      // Manejar diferentes formatos de fecha string
      if (value.includes('/')) {
        // Formato DD/MM/YYYY
        const parts = value.split('/');
        if (parts.length === 3) {
          const day = parseInt(parts[0], 10);
          const month = parseInt(parts[1], 10);
          const year = parseInt(parts[2], 10);
          date = new Date(year, month - 1, day);
        } else {
          date = new Date(value);
        }
      } else {
        date = new Date(value);
      }
    } else {
      return null;
    }
    
    if (isNaN(date.getTime())) {
      return null;
    }
    
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear()
    };
  }

  toModel(date: NgbDateStruct | null): string | null {
    if (!date) return null;
    return `${this.pad(date.day)}/${this.pad(date.month)}/${date.year}`;
  }

  private pad(i: number): string {
    return i < 10 ? `0${i}` : `${i}`;
  }
}

@Injectable()
export class CustomDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (!value || value.trim() === '') {
      return null;
    }

    const dateParts = value.trim().split(this.DELIMITER);
    
    if (dateParts.length === 3) {
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10);
      const year = parseInt(dateParts[2], 10);

      // Validar que los valores sean números válidos
      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        // Validar rangos básicos
        if (day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= 2100) {
          return { day, month, year };
        }
      }
    }
    
    return null;
  }

  format(date: NgbDateStruct | null): string {
    if (!date || !date.day || !date.month || !date.year) {
      return '';
    }
    return `${this.pad(date.day)}${this.DELIMITER}${this.pad(date.month)}${this.DELIMITER}${date.year}`;
  }

  private pad(i: number): string {
    return i < 10 ? `0${i}` : `${i}`;
  }
}
